import { Container } from '@material-ui/core';
import Page from '../components/Page';
import EmployerSetup from '../components/settings/EmployerSetup';

export default function NewProduct() {
  return (
    <Page title="Dashboard: Blog | ZIMTA">
      <Container>
        <EmployerSetup />
      </Container>
    </Page>
  );
}
